module.exports = __webpack_public_path__ + "b2302e27abf85a9be5f0977ed85cfe23.svg";